import { Autocomplete, DatePicker, Input } from '@fullscreendigital/carrefour-dex-fe'
import { BooleanIconText } from 'components/core-ui/BooleanIconText'
import { ApproveFileWhite, DeleteFileRed, FileBlack } from 'icons'

export const getColumns = () => [
  {
    title: 'Nr. PV',
    field: 'pvNumber',
    align: 'left',
    type: 'string'
    // width: '80px'
  },
  {
    title: 'Locatie',
    field: 'storeName',
    align: 'left',
    type: 'string'
    // width: '100px'
  },
  {
    title: 'Data',
    field: 'date',
    align: 'left',
    type: 'string',
    width: '80px'
  },
  // {
  //   title: 'Categorie',
  //   field: 'categoryName',
  //   align: 'left',
  //   type: 'string',
  //   collapsible: true,
  //   // width: '180px'
  // },
  {
    title: 'Transportator',
    field: 'carrierName',
    align: 'left',
    type: 'string',
    collapsible: true,
    width: '140px'
  },
  {
    title: 'Destinatar',
    field: 'companyName',
    align: 'left',
    type: 'string',
    collapsible: true,
    width: '140px'
  },
  // {
  //   title: 'Rapoarte zilnice',
  //   field: 'dailyReports',
  //   align: 'left',
  //   type: 'string',
  //   collapsible: true,
  //   width: '150px',
  //   disableSorting: true
  // },
  {
    title: 'Nr total articole',
    field: 'totalArticles',
    align: 'left',
    type: 'string',
    collapsible: true,
    // width: '70px',
    disableSorting: true
  },
  {
    title: 'Greutatea totala calculata (kg)',
    field: 'totalCalculatedWeight',
    align: 'left',
    type: 'string',
    collapsible: true,
    // width: '70px',
    disableSorting: true
  },
  {
    title: 'Greutatea totala cantarita (kg)',
    field: 'measuredWeight',
    align: 'left',
    type: 'string',
    collapsible: true,
    // width: '70px',
    disableSorting: true
  },
  {
    title: 'Doc',
    field: 'documentNo',
    align: 'left',
    type: 'string',
    collapsible: true,
    disableSorting: true,
    width: '70px',
    render: (row: any) => (
      <BooleanIconText
        value={row.documentNo}
        successIcon={<ApproveFileWhite />}
        failureIcon={<DeleteFileRed />}
        neutralIcon={<FileBlack />}
        isSuccess={row.isHandedOver}
        isFailure={!row.isHandedOver && row.documentNo === 0}
        isNeutral={!row.isHandedOver && row.documentNo > 0}
      />
    )
  }
]

export const getFilters = (
  companyOptions: AutocompleteOption[],
  categoryOptions: AutocompleteOption[]
) => [
  {
    name: 'startDate',
    value: null,
    filter: <DatePicker label="Data inceput" variant="outlined" value={null} onChange={() => {}} />,
    type: 'date',
    label: 'Data inceput'
  },
  {
    name: 'endDate',
    value: null,
    filter: <DatePicker label="Data sfarsit" variant="outlined" value={null} onChange={() => {}} />,
    type: 'date',
    label: 'Data sfarsit'
  },
  {
    name: 'companyId',
    value: '',
    filter: <Autocomplete variant="outlined" label="Destinatar" options={companyOptions || []} />,
    type: 'autocomplete',
    label: 'Destinatar'
  },
  {
    name: 'categories',
    value: undefined,
    filter: (
      <Autocomplete variant="outlined" label="Categorii" options={categoryOptions || []} multiple />
    ),
    type: 'autocomplete',
    label: 'Categorii'
  },
  {
    name: 'pvNumber',
    label: 'Nr. PV',
    type: 'text',
    filter: <Input type="text" name="pvNumber" label="Nr. PV" variant="outlined" value="" />
  }
]
